import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TiimeTooltipModule } from 'tiime-material';

import { Prospect } from '@gi/models/prospect';

@Component({
  standalone: true,
  selector: 'app-prospect-cell',
  templateUrl: './prospect-cell.component.html',
  styleUrls: ['./prospect-cell.component.scss'],
  imports: [TiimeTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'tiime-cell', 'data-cy': 'prospect-cell' }
})
export class ProspectCellComponent {
  @Input({ required: true }) prospect: Prospect;
}
